import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  SelectChangeEvent,
  SxProps,
  Theme,
} from "@mui/material";

interface CoAgent {
  id?: number;
  name?: string;
}

interface CoAgentFilterSelectProps {
  coAgents: CoAgent[];
  selectedCoAgentIds: number[];
  onChange: (coAgentIds: number[]) => void;
  label?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}

export const CoAgentFilterSelect: React.FC<CoAgentFilterSelectProps> = ({
  coAgents,
  selectedCoAgentIds,
  onChange,
  label = "Team Members/Co-Agents",
  fullWidth = true,
  size = "small",
  sx,
}) => {
  const handleChange = (e: SelectChangeEvent<number[]>) => {
    const value = e.target.value as number[];
    onChange(value);
  };

  return (
    <FormControl fullWidth={fullWidth} size={size} sx={sx}>
      <InputLabel shrink={true}>{label}</InputLabel>
      <Select
        multiple
        notched={true}
        value={selectedCoAgentIds}
        displayEmpty
        onChange={handleChange}
        label={label}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return "All Team Members";
          }

          if (selected.length > 3) {
            return `${selected.length} team members selected`;
          }

          return selected
            .map((id) => coAgents.find((ca) => ca.id === id)?.name)
            .filter(Boolean)
            .join(", ");
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {coAgents.map((coAgent) => (
          <MenuItem key={coAgent.id} value={coAgent.id}>
            <Checkbox
              checked={
                coAgent.id !== undefined &&
                selectedCoAgentIds.indexOf(coAgent.id) > -1
              }
            />
            <ListItemText primary={coAgent.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
